import axios from "axios"

export default async function fetchQuestionnaire(eventId: any) {
    const { data } = await axios.get(
        `${process.env.NEXT_PUBLIC_API_URL}events/questionaire/${eventId}`
    )
    return data
}
